__turbopack_context__.v({
  "gridThreeColumns": "CDuYaa_gridThreeColumns",
  "gridTwoColumns": "CDuYaa_gridTwoColumns",
  "icon": "CDuYaa_icon",
  "inlineCenter": "CDuYaa_inlineCenter",
  "inlineLeft": "CDuYaa_inlineLeft",
  "item": "CDuYaa_item",
  "itemWrapper": "CDuYaa_itemWrapper",
  "list": "CDuYaa_list",
  "root": "CDuYaa_root",
  "supportingText": "CDuYaa_supportingText",
  "textWrapper": "CDuYaa_textWrapper",
});
